import { forwardRef } from "react";
import PropTypes from "prop-types";
import SoftSwitchRoot from "./SoftSwitchRoot";

const SoftSwitch = forwardRef(
  ({ checked = false, onChange, disabled = false, color = "success", size = "small", ...rest }, ref) => (
    <SoftSwitchRoot ownerState={{ checked, disabled, color, size }}>
      <input
        ref={ref}
        type="checkbox"
        role="switch"
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        {...rest}
      />
      <span className="soft-switch-thumb" aria-hidden="true" />
    </SoftSwitchRoot>
  )
);

SoftSwitch.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "error",
    "info",
    "success",
    "warning",
    "default",
  ]),
  size: PropTypes.oneOf(["small", "medium"]),
};

export default SoftSwitch;
